import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatRadioModule } from "@angular/material/radio";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { TranslateModule } from "@ngx-translate/core";
import { MatCheckboxModule } from "@angular/material/checkbox";

enum AnswerOption {
	PROTRUDE = "protrude",
	RETRUDE = "retrude",
	PROCLINE = "procline",
	RECLINE = "recline",
	COMPRESS = "compress",
	EXPAND = "expand",
	TORQUE = "torque"
}

enum MovementTypeFormGroupName {
	PROTRUDE_RETRUDE = 'protrude_retrude',
	PROCLINE_RECLINE = 'procline_recline',
	COMPRESS_EXPAND = 'compress_expand',
	TORQUE = 'torque'
}

@Component({
	selector: "anterior-teeth-form",
	standalone: true,
	imports: [
		CommonModule,
		MatRadioModule,
		MatFormFieldModule,
		MatInputModule,
		MatCheckboxModule,
		TranslateModule,
		ReactiveFormsModule
	],
	templateUrl: "./anteriorTeethForm.component.html",
	styleUrl: "./anteriorTeethForm.component.scss"
})
export class AnteriorTeethFormComponent implements OnInit {
	@Input() parentForm: FormGroup;
	@Input() isUpperJaw: boolean;
	@Input() nestedFormGroupName: string;

	AnswerOption = AnswerOption;
	MovementTypeFormGroupName = MovementTypeFormGroupName;

	jawFormControlName: string;

	protrudeGroup: FormGroup;
	proclineGroup: FormGroup;
	compressGroup: FormGroup;
	torqueGroup: FormGroup;

	formGroups: FormGroup[];


	ngOnInit(): void {
		this.jawFormControlName = this.isUpperJaw ? 'uj' : 'lj';

		this.protrudeGroup = this.parentForm.get(`${this.nestedFormGroupName}.${this.jawFormControlName}.${MovementTypeFormGroupName.PROTRUDE_RETRUDE}`) as FormGroup;
		this.proclineGroup = this.parentForm.get(`${this.nestedFormGroupName}.${this.jawFormControlName}.${MovementTypeFormGroupName.PROCLINE_RECLINE}`) as FormGroup;
		this.compressGroup = this.parentForm.get(`${this.nestedFormGroupName}.${this.jawFormControlName}.${MovementTypeFormGroupName.COMPRESS_EXPAND}`) as FormGroup;
		this.torqueGroup = this.parentForm.get(`${this.nestedFormGroupName}.${this.jawFormControlName}.${MovementTypeFormGroupName.TORQUE}`) as FormGroup;

		this.formGroups = [this.protrudeGroup, this.proclineGroup, this.compressGroup, this.torqueGroup];

		this.formGroups.forEach( group => {
			const textFormControl = group.get('text');
			const optionFormControl = group.get('option');

			//set en-/disabled state depending on value (e.g. should not be disabled when form is prefilled)
			if(textFormControl.value || optionFormControl.value){
				textFormControl.enable({emitEvent: false});
			}else{
				textFormControl.disable({emitEvent: false});
			}

			optionFormControl?.valueChanges.subscribe((value) =>{
				if ( value ){
					textFormControl?.enable({emitEvent: false});
				}else{
					textFormControl?.disable({emitEvent: false});
				}
			})
		} );
	}

	onClick( answerOption: AnswerOption, movementTypeFormGroupName: MovementTypeFormGroupName){
		const formControl =  this.parentForm.get(`${this.nestedFormGroupName}.${this.jawFormControlName}.${movementTypeFormGroupName}`) as FormControl;
		if (answerOption === formControl.get('option')?.value) {
			formControl.patchValue({ option: null, text: null });
		}
	}

}
